import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { BiArrowBack } from "react-icons/bi";
import Footer from "../../../SharedFiles/Footer/Footer";
import { toast, Toaster } from "react-hot-toast";
import { HashLoader } from "react-spinners";
import {
  GetPickListNum,
  GetDeliveryList,
  GetItem,
  PostDeliveryPL,
  GetDeliveryDataByBatch,
} from "../../../APIServices/ProductionService/DeliveryService/DeliveryServiceThunk";
import DeliveryModal from "./deliveryModal";
import DeliveryTable from "./deliveryTable";
import CommonSearch from "../../../SharedFiles/CommonSearch/CommonSearch";
import { commonFilter, parseFormattedQRText } from "../../../SharedFiles/Helper/utils";
import {
  showNavigateConfirmation,
  showSubmitConfirmation,
  showWarningConfirmation,
} from "../../../SharedFiles/WarningMessage/deleteWarning";
import { useTranslation } from "react-i18next";

const DeliveryMain = () => {
  const [values, setValues] = useState({});
  // const [input,setInput]=useState({});
  const [searchTerm, setSearchTerm] = useState({});
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { t } = useTranslation();
  const [vehicleData, setVehicleData] = useState([]);
  const [modelOpen, setModelOpen] = useState(false);
  const [openManual, setOpenManual] = useState(true);
  const [editMode, setEditMode] = useState(false);
  const [QrTrigger, setQrTrigger] = useState(false);
  const [tableData, setTableData] = useState([]);
  const [tableHeader, setTableHeader] = useState([]);
  const [rowIndex, setRowIndex] = useState("");
  const [errorMessage, setErrorMessage] = useState({});
  const [deliveryQty, setDeliveryQty] = useState([]);
  const [remainingQty, setRemainingQty] = useState([]);
  const [dldataBatchNum, setDLdataBatchNum] = useState([]);
  const [isModalSubmitted, setIsModalSubmitted] = useState(false);
  const [GettingScannedData, setGettingScannedData] = useState(false);
  const [InProgress, setInProgress] = useState({
    vehicleData: false,
    PickList: false,
    PickListItem: false,
    PickListbatch: false,
    PostDeliveryCall: false,
    scanBatchData: false,
  });
  const {
    GetPlNum,
    Getitem,
    GetdeliveryList,
    DeliveryDataByBatch,
    PostDeliveryResponse,
    loading,
    error,
  } = useSelector((state) => state.delivery);

  const isLoading = () => {
    return (
      loading.GetPlNum ||
      loading.Getitem ||
      loading.GetdeliveryList ||
      loading.PostDeliveryResponse ||
      loading.DeliveryDataByBatch
    );
  };
  // useEffect(() => {
  //   if (dldataBatchNum) {
  //     if (QrTrigger && DeliveryDataByBatch && Getitem && Getitem.length > 0) {
  //       const filtered = DeliveryDataByBatch.filter((item) =>
  //         item.batch_Number.toLowerCase().includes(dldataBatchNum.toLowerCase())
  //       );
  //       if (filtered.length > 0) {
  //         const matchedItem = filtered[0];
  //         setValues({
  //           item_Code: matchedItem.item_Code,
  //           batch_Number: matchedItem.batch_Number,
  //           Kg: matchedItem.quantity,
  //           Quantity_Nos: matchedItem.u_QTYINNOS,
  //           Receipt_Type: matchedItem.u_RECEIPTTYPE,
  //           description: matchedItem.itemName,
  //         });
  //         setOpenManual(true);
  //       } else {
  //         // If no matching batch found
  //         toast.error(t('Batch Number not found!'));
  //         setOpenManual(false);
  //       }
  //     }
  //   } else {
  //     toast.error(t('No Batch Number available'));
  //     setOpenManual(false); // Close the manual input form if no batch number is available
  //   }
  // }, [DeliveryDataByBatch, QrTrigger, dldataBatchNum, Getitem]);

  const inputfieldLabel =
    GetPlNum && GetPlNum.length > 0
      ? Object.keys(GetPlNum[0]).filter(
        (key) =>
          key !== "name" &&
          key !== "wbDocEntry" &&
          key !== "code" &&
          key !== "pick_List_Number" &&
          key !== "order_DocEntry" &&
          key !== "lastCode"
      )
      : [];

  useEffect(() => {
    if (!GetPlNum) {
      setInProgress((prev) => ({
        ...prev,
        vehicleData: true,
      }));
      dispatch(GetPickListNum());
    }
  }, [dispatch, GetPlNum]);

  // useEffect(() => {
  //   if (InProgress.PostDeliveryCall && PostDeliveryResponse === "Success") {
  //     toast.success(t('Submitted successfully'));
  //     setInProgress({ ...InProgress, PostDeliveryCall: false });
  //     setTableData([]);
  //     setTableHeader([]);
  //     setRowIndex("");
  //     setEditMode(false);
  //   }
  //   if (InProgress.PostDeliveryCall && error.PostDeliveryResponseError) {
  //     setInProgress((prev) => ({
  //       ...prev,
  //       PostDeliveryCall: false,
  //     }));
  //     const errormessage = error.PostDeliveryResponseError;
  //     toast.error(`${errormessage}`);
  //   }
  // }, [PostDeliveryResponse, error, InProgress]);

  const batchChecker = () => {
    // if (InProgress.PostDeliveryCall && PostDeliveryResponse === "Success") {
      if (InProgress.PostDeliveryCall && PostDeliveryResponse === "Success") {
      toast.success(t('Submitted successfully'));
      setInProgress({ ...InProgress, PostDeliveryCall: false });
      setTableData([]);
      setTableHeader([]);
      dispatch(GetPickListNum());
      setRowIndex("");
      setEditMode(false);
    }
    if (InProgress.PostDeliveryCall && error.PostDeliveryResponseError) {
      setInProgress((prev) => ({
        ...prev,
        PostDeliveryCall: false,
      }));      
      const errormessage = error.PostDeliveryResponseError;
      toast.error(`${errormessage}`);
    }
  
    if (InProgress.PickList && error.GetitemError) {
      const errorss = error.GetitemError;
      const status = errorss.errorCode;
      const errormessage = errorss;
      setInProgress({ ...InProgress, PickList: false });
      toast.error(errormessage);
      setModelOpen(false);
      return;
    }
    if (InProgress.PickListItem && error.GetdeliveryListError) {
      const errorss = error.GetdeliveryListError;
      const errormessage = errorss.errorMessage;
      setInProgress({ ...InProgress, PickListItem: false });
      toast.error(errormessage);
    }
    if (InProgress.vehicleData && error.GetPlNumError) {
      const errorss = error.GetPlNumError;
      const errormessage = errorss.errorMessage;
      setInProgress({ ...InProgress, vehicleData: false });
      toast.error(errormessage);
    }
    if (InProgress.scanBatchData && error.DeliveryDataByBatchError) {
      const errorss = error.DeliveryDataByBatchError;
      const status = errorss.errorCode;
      const errormessage = errorss.errorMessage;
      setInProgress({ ...InProgress, scanBatchData: false });
      // if (status === 400) {
      toast.error(`${errormessage}`);
      // }
    }
  };
  useEffect(() => {
    batchChecker(); // Call batchChecker every time DisassembleBatch or error changes
  }, [
    GetPlNum,
    Getitem,
    GetdeliveryList,
    PostDeliveryResponse,
    DeliveryDataByBatch,
    loading,
    error,
    InProgress,
  ]);

  const handleSearchDrop = (item) => {
    setTableData([]);
    const vehiclePlNum = `${item.vehicle_Number}/${item.pick_List_Number}`;
    setVehicleData(item);
    setSearchTerm((prevValues) => ({
      ...prevValues,
      vehicle_Number: vehiclePlNum,
    }));
    const DocEntry = item.pick_List_Number;
    dispatch(GetItem({ DocEntry }));
    setInProgress({ ...InProgress, PickList: true });
    setModelOpen(true);
    setOpenManual(false);
    setEditMode(false);
  };
  const handleSelectItem = (item, field) => {
    setValues({});
    if (field === "item_Code") {
      setValues((prevValues) => ({
        ...prevValues,
        item_Code: item.item_Code,
        description: item.description, // Set the corresponding description
      }));
    } else if (field === "description") {
      setValues((prevValues) => ({
        ...prevValues,
        description: item.description, // Set the description
        item_Code: item.item_Code, // Set the corresponding itemCode
      }));
    }
    setErrorMessage((prevState) => ({
      ...prevState,
      [field]: "", // Clear the error message for item_Code
    }));
    dispatch(GetDeliveryList({ itemCode: item.item_Code }));
    setInProgress({ ...InProgress, PickListItem: true });
  };

  const onEdit = (action, rowIndex) => {
    const selectedRow = tableData[rowIndex];
    setRowIndex(rowIndex);
    setValues(selectedRow);
    setEditMode(true);
    setModelOpen(true);
  };
  useEffect(() => {
    if (Getitem && Getitem.length > 0) {
      const sumQTYTORELEASE =
        Getitem &&
        Getitem.reduce((total, item) => total + item.u_QTYTORELEASE, 0);
      setDeliveryQty(sumQTYTORELEASE);
      setRemainingQty(sumQTYTORELEASE - Getitem[0].deliveredQty)
    }
  }, [Getitem]);
  
  const onSubmit = (submissionData) => {
    let newErrorMessage = {};
    if(!GettingScannedData) {
    const isItemCodeValid = Getitem.some(
      (item) => item.item_Code === submissionData.item_Code
    );
    const isItemNameValid = Getitem.some(
      (item) => item.description === submissionData.description
    );
    const isbatchValid = GetdeliveryList.some(
      (item) => item.batch_Number === submissionData?.batch_Number
    )
    if (!submissionData.item_Code) {
      newErrorMessage.item_Code = `select item_Code`;
    } else if (!isItemCodeValid) {
      newErrorMessage.item_Code = `Error: item_Code ${submissionData.item_Code} does not exist in the system.`;
    } else if (!isItemNameValid) {
      newErrorMessage.description = `Error: item_Name ${submissionData.description} does not exist in the system.`;
    } else if (!isbatchValid) {
      newErrorMessage.batch_Number = `Error: batch_Number ${submissionData.batch_Number} does not exist in the system.`;
    } else if (submissionData.Kg === "0" || submissionData.Kg === "") {
      newErrorMessage.Kg = ` Weight can't be empty or zero!`;
    } else if (
      submissionData.quantity_Nos === 0 ||
      !submissionData.quantity_Nos
    ) {
      newErrorMessage.quantity_Nos = `Quantity can't be empty or zero!`;
    }
  }
    if (Object.keys(newErrorMessage).length > 0) {
      setErrorMessage(newErrorMessage);
      return;
    }
    const isBatchNumExist = tableData.some(
      (row) => row.batch_Number === submissionData.batch_Number
    );
    if (!editMode && isBatchNumExist) {
      toast.error(t('Batch Number already exists'));
      setModelOpen(true);
      return;
    }
    if (isBatchNumExist && !editMode) {
      toast.error(t('Batch Number already exists'));
      setModelOpen(true);
      return;
    }

    const totalQuantity =
      tableData.reduce(
        (acc, row) => acc + (parseInt(row.quantity_Nos, 10) || 0),0) + (parseInt(submissionData.quantity_Nos, 10) || 0);
    // if (totalQuantity > deliveryQty) {
    //   toast.error("Total Quantity exceeds delivery quantity!");
    //   setModelOpen(true);
    //   return;
    // }
    const totalitemQuantity = tableData
      .filter(row => row.item_Code === submissionData.item_Code)  // Filter rows based on itemCode
      .reduce((acc, row) => acc + (row.quantity_Nos || 0), 0)  // Sum the quantities for the matched itemCode
      + (submissionData.quantity_Nos || 0);
    const inputdata = commonFilter(Getitem, 'item_Code', submissionData.item_Code)
    if (totalitemQuantity > inputdata[0].u_QTYTORELEASE) {
      toast.error(t('Total item quantity exceeds delivery quantity!'));
      setModelOpen(true);
      return;
    }
    setRemainingQty(remainingQty - submissionData.quantity_Nos);

    // Proceed with adding the row to tableData if no duplicate batchNum
    if (submissionData && Object.keys(submissionData).length > 0) {
      setTableHeader(Object.keys(submissionData)); // Update header if needed
    } else {
      setTableHeader([]);
    }
    if (editMode) {
      const updatedRow = [...tableData];
      updatedRow[rowIndex] = {
        ...submissionData,
      };
      setTableData(updatedRow);
    } else {
      setTableData((prevData) => [...prevData, submissionData]);
    }
    setModelOpen(false);
    setEditMode(false);
    setIsModalSubmitted(true);
    setGettingScannedData(false)
    setValues({
      item_Code: "",
      description: "",
      batch_Number: "",
      quantity_Nos: "",
      quantity: "",
      receipt_Type: "",
    });
  };
  // const handleQrScan = (scanResult) => {
  //   setQrTrigger(true);
  //   scanResult = JSON.parse(scanResult);
  //   if (scanResult && typeof scanResult === "object") {
  //     setValues((prevFormData) => {
  //       let updatedFormData = { ...prevFormData };
  //       updatedFormData.batch_Number = scanResult.Batch_Number;
  //       return updatedFormData;
  //     });
  //     setDLdataBatchNum(scanResult.Batch_Number);
  //     dispatch(GetDeliveryDataByBatch({ batchNumber: scanResult.Batch_Number }));
  //     setInProgress({ ...InProgress, scanBatchData: true });
  //   } else {
  //     toast.error(t('Batch Number is missing in the scan result'));
  //   }
  // };
  const handleQrScan = async (scanResult) => {
    let data;
    // try {
    //   data = parseFormattedQRText(scanResult);
    // } catch (err) {
    //   console.error("Invalid QR scan result:", err);
    //   return;
    // }
    // const batchNumber = data?.BatchNumber?.trim();
    const batchNumber = scanResult['batchnumber'].trim();
    if (!batchNumber) {
      toast.error(t('Batch Number not found!'));
      return;
    }
  
    setInProgress(prev => ({ ...prev, PickListbatch: true }));
  
  try {
  const result = await dispatch(GetDeliveryDataByBatch({ batchNumber })).unwrap();

  
  const matchingBatchNumbers = result?.filter(
   item => item.batchNum?.toLowerCase() === batchNumber.toLowerCase()
   );
  
  if (!matchingBatchNumbers.length) {
   toast.error(t('No matching records found.'));
  setValues({});
  setOpenManual(false);
  return;
  }
  
  const matchedItem = matchingBatchNumbers[0];
   setValues({
   item_Code: matchedItem.itemCode,
   batch_Number: matchedItem.batchNum,
   Kg: matchedItem.quantity,
   quantity_Nos: matchedItem.u_QTYINNOS,
   receipt_Type: matchedItem.u_RECEIPTTYPE,
   description: matchedItem.itemName,
   iWeight: matchedItem.iWeight
  });
  setOpenManual(true);    
  } catch (err) {
     toast.error(t('Failed to fetch delivery data.'));
   setValues({});
   setOpenManual(false);
  
  } finally {
   setInProgress(prev => ({
     ...prev,
     PickListbatch: false, 
     scanBatchData: false,
     PickListItem: true
    }));
   setGettingScannedData(true);
  }
  }
  

//   useEffect(()=> {
    
//  const matchingBatchNumbers = DeliveryDataByBatch &&DeliveryDataByBatch?.filter(
//           item => item.batch_Number?.toLowerCase() === batchNumber.toLowerCase()
//         );
//       if (!matchingBatchNumbers) {
//           toast.error(t('No matching records found.'));
//           return;
//       }else{
//         const matchedItem = matchingBatchNumbers[0];
//           setValues({
//             item_Code: matchedItem.item_Code,
//             batch_Number: matchedItem.batch_Number,
//             Kg: matchedItem.quantity,
//             Quantity_Nos: matchedItem.u_QTYINNOS,
//             Receipt_Type: matchedItem.u_RECEIPTTYPE,
//             description: matchedItem.itemName,
//           });
//           setOpenManual(true);
//       }
//   },[DeliveryDataByBatch,InProgress.PickListbatch])
 
  const handleAdd = () => {
    setModelOpen(true);
    setEditMode(false);
  };

  const handleTableDatasubmit = () => {
    const totalQuantity = tableData.reduce(
      (acc, row) => acc + (parseInt(row.quantity_Nos, 10) || 0),
      0
    );

    if (totalQuantity > deliveryQty) {
      // Show warning if totalQuantity is not equal to deliveryQty
      showWarningConfirmation(() => {
        // Proceed with submission if user confirms
        submitDeliveryData();
      });
      return;
    }
    submitDeliveryData();
  };
  // Function to submit the data
  const submitDeliveryData = () => {
    const dataToPost = tableData.length > 0 && [{
      code: (vehicleData?.code ? vehicleData?.code : 0).toString(),
      vehicleNo: vehicleData?.vehicle_Number,
      LastCode : vehicleData?.lastCode,
      pickListNo: vehicleData?.pick_List_Number.toString(),
      soDocEn: vehicleData?.order_DocEntry.toString(),
      wtBrightDE: vehicleData?.wbDocEntry || "",
      pickListDatas: tableData.map((item) => ({
        itemCode: item?.item_Code || "",
        itemName: item.description,
        batchNo: item?.batch_Number,
        netWt: String(item?.Kg),
        qtyNo: String(item?.quantity_Nos),
        stdWt:String(item?.Iweight*item?.quantity_Nos),
        iWeight:String(item?.Iweight)
      })),
    }];

    if (dataToPost) {
      setInProgress({ ...InProgress, PostDeliveryCall: true });
      dispatch(PostDeliveryPL(dataToPost));
    }
    setSearchTerm({});
  };



  const handleCloseDialog = () => {
    setModelOpen(false);
    setErrorMessage({});
    setValues({});
  };

  const handleNavigateConfirmation = () => {
    if (tableData.length > 0) {
      showNavigateConfirmation(handleBack);
    } else {
      handleBack();
    }
  };

  const handleBack = () => {
    navigate("/production/");
  };

  return (
    <>
      {/* <Header /> */}
      <div className="container mainDiv">
        <div className="col-12 gap-2 mb-1 d-flex align-items-center justify-content-between">
          <button onClick={handleNavigateConfirmation} className="goBackButton">
            <BiArrowBack size={24} />
          </button>
          <p className="m-0 fw-medium mx-3">{t('DELIVERY')}</p>
        </div>
        <div>
          <div className=" search-div">
            <CommonSearch
              inputFields={inputfieldLabel}
              values={searchTerm}
              setValues={setSearchTerm}
              data={GetPlNum}
              handleDropdownClick={handleSearchDrop}
            />
          </div>
          <div className="row mb-1">
            {/* <div className="col-12 d-flex justify-content-end"> */}
            <div className="col-12 d-flex justify-content-between ">
              {tableData.length > 0 && (
                <div className="d-flex justify-content-between gap-3 ">
                  <p className="m-0">{t('Delivery Qty')}: {deliveryQty}</p>
                  <p className="m-0">{t('Remaining Qty')}: {remainingQty}</p>
                </div>
              )}
              {isModalSubmitted && tableData.length > 0 && (
                <button className="button xs" onClick={handleAdd}>
                  {t('Add Item')}
                </button>
              )}
            </div>
          </div>
          <div className="tableMin">
            <DeliveryTable
              tablebody={tableData}
              setTableData={setTableData}
              header={tableHeader}
              onEdit={onEdit}
              remainingQty={remainingQty}
              setRemainingQty={setRemainingQty}
              pageName={"Delivery"}

            />
          </div>
          <div className="submit-button-container">
            {tableData.length > 0 && (
              <button className="button xs" onClick={handleTableDatasubmit}>
                {t('Submit')}
              </button>
            )}
          </div>
        </div>
        <DeliveryModal
          setModelOpen={setModelOpen}
          modelOpen={modelOpen}
          setOpenManual={setOpenManual}
          openManual={openManual}
          editMode={editMode}
          Getitem={Getitem}
          values={values}
          setValues={setValues}
          handleSearchDrop={handleSelectItem}
          InProgress={InProgress}
          setInProgress={setInProgress}
          handleCloseDialog={handleCloseDialog}
          onSubmit={onSubmit}
          setErrorMessage={setErrorMessage}
          handleQrScan={handleQrScan}
          errorMessage={errorMessage}
          tableData={tableData}
        />
      </div>
      <Toaster
        position="top-center"
        toastOptions={{
          style: {
            fontSize: "16px",
            padding: "16px",
            width: "400px",
            borderRadius: "8px",
          },
        }}
      />
      <div></div>
      {isLoading() && (
        <div className="loader">
          <HashLoader color="#ed1c24" />
        </div>
      )}

      <Footer />
    </>
  );
};

export default DeliveryMain;
